module.exports = "<h1 class=\"page-header text-center\">\n  Erreur 404\n</h1>\n\n<div class=\"text-center\">\n  Page introuvable\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagenotfound/pagenotfound.component.html
// module id = ./src/app/pagenotfound/pagenotfound.component.html
// module chunks = main